import axios from "axios";
import Config from "./config";
import authHeader from "./authHeader";

const candidateLogin = (data) => {
  console.log("loginUserdata", data);
  var formData = data;
  return axios.post(
    Config.API_URL + "api/v1/accounts/auth/generate-login-otp/",
    formData
  );
};
const staffLogin = (data) => {
  console.log("loginUserdata", data);
  var formData = data;
  return axios.post(
    Config.API_URL +
      "api/v1/accounts/auth/generate-staff-login-otp-career-portal/",
    formData
  );
};
const verifyOtp = (data) => {
  var nId = localStorage.getItem("user_id");
  var oData = {
    otp: data.otp,
    user: nId,
  };
  return axios.post(
    Config.API_URL + "api/v1/accounts/auth/validate-otp-and-login/",
    oData
  );
};
const candidateRegistrationServie = (data, fileName, dob) => {
  console.log("resume", data.resume);
  // const mobile_number = `+91${data.mobile_number}`;
  const formData = new FormData();
  // if (fileName) {
  //   formData.append("resume", fileName ? fileName : "");
  // }
  formData.append(
    "application_username",
    data.application_username ? data.application_username : ""
  );
  formData.append("email", data.email ? data.email : "");
  formData.append(
    "mobile_number",
    data.mobile_number ? data.mobile_number : ""
  );
  formData.append("password", data.password ? data.password : "");
  formData.append("first_name", data.first_name ? data.first_name : "");
  formData.append("last_name", data.last_name ? data.last_name : "");

  // formData.append("total_exp", data.total_exp ? Number(data.total_exp) : "");
  // formData.append(
  //   "current_location",
  //   data.current_location ? data.current_location : ""
  // );
  // formData.append(
  //   "notice_period",
  //   data.notice_period ? Number(data.notice_period) : 0
  // );
  // formData.append("candidate_details", JSON.stringify(arrayOptions));
  // formData.append(
  //   "current_ctc",
  //   data.current_ctc ? Number(data.current_ctc) : 0
  // );
  // formData.append("dob", dob ? dob : "");
  // formData.append(
  //   "other_skills",
  //   data.other_skills ? JSON.stringify(data.other_skills) : ""
  // );
  // formData.append("comments", data.comments ? data.comments : "");
  // formData.append("candidate_city", data.candidate_city ? data.candidate_city : "");
  // formData.append("candidate_state", data.candidate_state ? data.candidate_state : "");
  // formData.append("candidate_country", data.candidate_country ? data.candidate_country : "");

  return axios.post(
    Config.API_URL + "api/v1/accounts/candidate_registration/",
    formData
  );
};

const updateCandidateRegistration = (
  data,
  candidateToken,
  fileName,
  arrayOptions,
  optionskills,
  optionEducations,

  dob
) => {
  console.log("resume", data.resume);
  // const mobile_number = `+91${data.mobile_number}`;
  const formData = new FormData();
  formData.append("candidate_credentials", JSON.stringify(arrayOptions));
  formData.append("password", data.password ? data.password : "");
  if (fileName) {
    formData.append("resume", fileName ? fileName : "");
  }
  // formData.append("skills", JSON.stringify(optionskills));
  // formData.append("qualifications", JSON.stringify(optionEducations));
  // formData.append("password", data.password ? data.password : "");

  // formData.append("total_exp", data.total_exp ? Number(data.total_exp) : "");
  // formData.append(
  //   "current_location",
  //   data.current_location ? data.current_location : ""
  // );
  // formData.append(
  //   "notice_period",
  //   data.notice_period ? Number(data.notice_period) : 0
  // );
  // formData.append(
  //   "current_ctc",
  //   data.current_ctc ? Number(data.current_ctc) : 0
  // );
  // formData.append("dob", dob ? dob : "");
  // formData.append(
  //   "other_skills",
  //   data.other_skills ? JSON.stringify(data.other_skills) : ""
  // );
  // formData.append("comments", data.comments ? data.comments : "");
  // formData.append(
  //   "candidate_city",
  //   data.candidate_city ? data.candidate_city : ""
  // );
  // formData.append(
  //   "candidate_state",
  //   data.candidate_state ? data.candidate_state : ""
  // );
  // formData.append(
  //   "candidate_country",
  //   data.candidate_country ? data.candidate_country : ""
  // );

  return axios.put(
    Config.API_URL +
      `api/v1/candidates/candidate-details-from-career/${candidateToken?.candidate}/?company=${candidateToken.company}`,
    formData
  );
};
const resumeUpload = (fileName) => {
  const formData = new FormData();
  if (fileName) {
    formData.append("resumes", fileName ? fileName : "");
  }
  return axios.post(
    Config.API_URL + `api/v1/uploads/resume-upload-career/`,
    formData
  );
};
const ForgetPassword = (data) => {
  return axios.post(Config.API_URL + "api/v1/accounts/forgot-password/", {
    email_or_mobile_number: data.email_or_mobile_number,
    is_candidate: true,
    company_domain: "http://ndz.yvi.ai",
  });
};
const skillsDetails = (skillSearch) => {
  return axios.get(
    Config.API_URL + `api/v1/settings/master-skills/?search=${skillSearch}`
  );
};
const educationDetails = (educationSearch) => {
  return axios.get(
    Config.API_URL +
      `api/v1/settings/master-educations/?search=${educationSearch}`
  );
};
const certificationDetails = (certificationsSearch) => {
  return axios.get(
    Config.API_URL +
      `api/v1/settings/master-certifications/?search=${certificationsSearch}`
  );
};
const certificationDetailsbyId = (id) => {
  console.log("testu", id);
  return axios.get(
    Config.API_URL +
      `api/v1/settings/master-certifications/${id ? id + "/" : ""}`
  );
};
const telePort = (serachValue) => {
  return axios.get(
    `https://api.teleport.org/api/cities/?search= + ${serachValue}, `
  );
};
const getLanguages = (serachValue) => {
  return axios.get(
    Config.API_URL + `api/v1/settings/languages/?search=${serachValue}`,
    {
      headers: authHeader(),
    }
  );
};

const getLocations = (serachValue) => {
  return axios.get(
    Config.API_URL + `api/v1/settings/locations/?search=${serachValue}`,
    {
      headers: authHeader(),
    }
  );
};

const getNationality = (serachValue) => {
  return axios.get(
    Config.API_URL + `api/v1/settings/nationalities/?search=${serachValue}`,
    {
      headers: authHeader(),
    }
  );
};
const getPreferredWorkingCondition = () => {
  return axios.get(Config.API_URL + `api/v1/uploads/working-conditions/`, {
    headers: authHeader(),
  });
};
const getCompanyLogoWithoutLogin = () => {
  return axios.get(
    Config.API_URL + `api/v1/settings/company-basic-info-without-login/`
  );
};
const getCompanyLogoWithLogin = () => {
  return axios.get(Config.API_URL + `api/v1/settings/company-basic-info/`, {
    headers: authHeader(),
  });
};
const candidateDetails = (token) => {
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/candidate-details-from-career/${token?.candidate}/?company=${token.company}`
  );
};

const ResetPassword = (data) => {
  return axios.post(
    Config.API_URL +
      `api/v1/accounts/user_password_reset/${data?.code}/${data?.token}/`,
    {
      password: data.password,
      confirm_password: data.confirm_password,
    }
  );
};
const signupResumeUpload = (file) => {
  const formData = new FormData();

  formData.append("resume", file);
  return axios.post(
    Config.API_URL + `api/v1/candidates/career-resume-extraction/`,
    formData
  );
};
const signupConfirmation = (formData) => {
  return axios.post(
    Config.API_URL + `api/v1/candidates/generate-register-otp/`,
    formData
  );
};
const OtpVerification = (otp) => {
  var nId = localStorage.getItem("candidate_id");

  var payload = {
    email_otp: JSON.parse(otp),
    // mobile_otp: JSON.parse(data.mobile_otp),
    user_id: JSON.parse(nId),
  };
  // const parsedPayload = JSON.parse(payload);
  // console.log("parsedPayload", parsedPayload);
  return axios.post(
    Config.API_URL + `api/v1/candidates/register-otp-verification/`,
    payload
  );
};
const resendOtp = () => {
  var nId = localStorage.getItem("candidate_id");
  var payload = {
    user: JSON.parse(nId),
  };
  return axios.put(
    Config.API_URL + `api/v1/candidates/generate-register-otp/`,
    payload
  );
};
const AuthService = {
  candidateLogin,
  candidateRegistrationServie,
  skillsDetails,
  educationDetails,
  ForgetPassword,
  certificationDetails,
  telePort,
  getLanguages,
  getNationality,
  certificationDetailsbyId,
  getCompanyLogoWithoutLogin,
  getCompanyLogoWithLogin,
  candidateDetails,
  updateCandidateRegistration,
  getPreferredWorkingCondition,
  ResetPassword,
  getLocations,
  resumeUpload,
  verifyOtp,
  signupResumeUpload,
  signupConfirmation,
  OtpVerification,
  resendOtp,
  staffLogin,
};
export default AuthService;
